import { STORAGE_KEY_SEARING_SEARCH_HISTORY } from '@/constants/storage';

const MAX_ITEMS = 50;
const MAX_KEYWORD_LENGTH = 32;

function safeParse(raw: string | null): string[] {
    if (!raw) {
        return [];
    }
    try {
        const data = JSON.parse(raw) as unknown;
        if (!Array.isArray(data)) {
            return [];
        }
        return data.filter((x): x is string => typeof x === 'string');
    } catch {
        return [];
    }
}

export function getSearchHistory(): string[] {
    if (typeof window === 'undefined') {
        return [];
    }
    return safeParse(localStorage.getItem(STORAGE_KEY_SEARING_SEARCH_HISTORY));
}

/** 去重：与已有完全相同（trim 且截断至 32 字符后）的条目移除，新词置顶 */
export function addSearchHistory(keyword: string): void {
    if (typeof window === 'undefined') {
        return;
    }
    const next = keyword.trim().slice(0, MAX_KEYWORD_LENGTH);
    if (!next) {
        return;
    }
    const prev = getSearchHistory();
    const merged = [next, ...prev.filter(k => k !== next)].slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY_SEARING_SEARCH_HISTORY, JSON.stringify(merged));
}

export function clearSearchHistory(): void {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.removeItem(STORAGE_KEY_SEARING_SEARCH_HISTORY);
}
